// =============================================================================
//  Copyright : 2025 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : wiki/hocr based fulltext rendering support
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import {Sel} from 'uix/registries'
import log from 'uix/logging'
import {useSelector, useApi} from 'uix/hooks'

// ---Local imports
import {WikiPane} from '../render'

// ---Globals
export const FulltextRenderPane = ({otid}) => {
  let {data, error} = useApi('fulltext/getRendering', {otid}, {autoreset: false, condition: !!otid})
  let rendering = data?.fulltextRendering || {}

  return <WikiPane rendered={rendering.rendered} paneKey="textrender" otid={rendering.otid} />
}

export const FulltextPreviewPane = ({otid, hocr}) => {
  let {data, error} = useApi(
    'fulltext/getRenderingPreview',
    {otid, hocr},
    {autoreset: false, condition: !!otid, method: 'post'}
  )
  let rendering = data?.fulltextRendering || {}

  return <WikiPane rendered={rendering.rendered} paneKey="textpreview" otid={otid} />
}
